import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "ms-5 d-flex align-items-center" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table-tenant" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "Party Id", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "dialog-footer" }

import { ref, onMounted, inject } from "vue";
import AccountService from "../../services/AccountService";
import VueJsonView from "@matpool/vue-json-view";
import { AccountRoleTypes } from "@/core/types/AccountInfos";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralCode',
  setup(__props) {

const isLoading = inject<any>("isLoading");
const infoLoading = ref(false);
const show = ref(false);
const dialogData = ref(<any>[]);
const data = ref(<any>[]);
const criteria = ref({
  code: "",
  page: 1,
  size: 20,
});
const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await AccountService.getReferralCode(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};
const fetchDetail = async (code: string) => {
  infoLoading.value = true;
  try {
    const res = await AccountService.getReferralCodeDetailByCode(code);
    dialogData.value = res;
  } catch (error) {
    console.log(error);
  } finally {
    infoLoading.value = false;
  }
};
const showSchema = (data: any) => {
  show.value = true;
  dialogData.value = data;
};
const showDetail = (item: any) => {
  show.value = true;
  fetchDetail(item.code);
  dialogData.value = item;
};
const pageChange = (page: number) => {
  fetchData(page);
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("fields.referralCode")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_input, {
              class: "w-150px",
              modelValue: criteria.value.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.code) = $event)),
              placeholder: _ctx.$t('fields.code')
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_el_button, {
              class: "ms-5",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1))),
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "ms-3",
              type: "warning",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.code = ''), fetchData(1))),
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.referralCode")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.referralCodeName")), 1),
              _hoisted_8,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountId")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.serviceType")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!_unref(isLoading) && data.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.code), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.partyId), 1),
                      _createElementVNode("td", null, _toDisplayString(item.accountId), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(AccountRoleTypes)[item.serviceType]), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (showSchema(item.displaySummary))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.viewScheme")) + " (SuperAdmin) ", 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "success",
                          onClick: ($event: any) => (showDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.detail")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
      width: "700",
      "align-center": "",
      style: {"max-height":"95vh","overflow":"auto"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (show.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (infoLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_LoadingRing)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (typeof dialogData.value != 'object')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(dialogData.value), 1))
                : (_openBlock(), _createBlock(_unref(VueJsonView), {
                    key: 1,
                    src: dialogData.value,
                    theme: "rjv-default"
                  }, null, 8, ["src"]))
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})